(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-tween-bundle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBundle = (sectionEl) => {
      if (sectionEl.dataset.bundleInitialized === 'true') return;
      sectionEl.dataset.bundleInitialized = 'true';

      const thumbs = sectionEl.querySelectorAll('[data-thumb-index]');
      const slides = sectionEl.querySelectorAll('[data-media-slide]');
      const showMedia = (index) => {
        thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.thumbIndex === index));
        slides.forEach((slide) => {
          const active = slide.dataset.mediaSlide === index;
          slide.classList.toggle('is-active', active);
          if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
      };
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => showMedia(thumb.dataset.thumbIndex));
      });

      const form = sectionEl.querySelector('[data-tween-bundle-form]');
      if (!form) return;
      const baseSelect = form.querySelector('[data-bundle-base]');
      const addButton = form.querySelector('[data-bundle-add]');
      if (baseSelect) {
        const price = sectionEl.querySelector('[data-product-price]');
        const comparePrice = sectionEl.querySelector('[data-product-compare-price]');
        const preview = form.querySelector('[data-bundle-base-preview]');
        const component = form.querySelector('[data-bundle-base-component]');
        const selection = form.querySelector('[data-bundle-base-selection]');
        const sharedPhoto = form.querySelector('[data-bundle-base-shared-photo]');
        const details = form.querySelector('[data-bundle-base-details]');
        const updateBase = () => {
          const option = baseSelect.selectedOptions[0];
          const available = option?.dataset.available === 'true' && !option.disabled;
          if (price && option) {
            price.textContent = option.dataset.price;
            price.classList.toggle('msc-product-hero__price--sale', Boolean(option.dataset.comparePrice));
          }
          if (comparePrice) {
            comparePrice.textContent = option?.dataset.comparePrice || '';
            comparePrice.style.display = option?.dataset.comparePrice ? '' : 'none';
          }
          if (addButton) {
            addButton.disabled = sectionEl.dataset.bundleReady !== 'true' || !available;
            addButton.textContent = addButton.disabled ? addButton.dataset.unavailableLabel : addButton.dataset.addLabel;
          }
          if (component) component.hidden = !option?.dataset.previewImage;
          if (selection) selection.textContent = option?.dataset.baseTitle || '';
          if (sharedPhoto) sharedPhoto.hidden = option?.dataset.baseSharedPhoto !== 'true';
          if (details) {
            details.hidden = !option?.dataset.baseDetailsUrl;
            if (option?.dataset.baseDetailsUrl) details.href = option.dataset.baseDetailsUrl;
            else details.removeAttribute('href');
          }
          if (preview) {
            preview.hidden = !option?.dataset.previewImage;
            if (option?.dataset.previewImage) {
              preview.src = option.dataset.previewImage;
              preview.alt = option.dataset.previewAlt || option.dataset.baseTitle;
            } else {
              preview.removeAttribute('src');
            }
          }
        };
        baseSelect.addEventListener('change', updateBase);
        updateBase();
      }
      form.querySelectorAll('[data-bundle-face]').forEach((select) => {
        const preview = select.parentElement.querySelector('[data-bundle-face-preview]');
        const component = select.parentElement.querySelector('[data-bundle-face-component]');
        const updatePreview = () => {
          const imageUrl = select.selectedOptions[0]?.dataset.previewImage;
          if (!preview) return;
          if (component) component.hidden = !imageUrl;
          preview.hidden = !imageUrl;
          if (imageUrl) {
            preview.src = imageUrl;
            preview.alt = select.value;
          } else {
            preview.removeAttribute('src');
          }
        };
        select.addEventListener('change', updatePreview);
        updatePreview();
      });
      form.addEventListener('submit', (event) => {
        if (!form.reportValidity() || sectionEl.dataset.bundleReady !== 'true' || addButton?.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      });
    };

    const initializeBundles = (scope) => {
      scope.querySelectorAll('[data-tween-bundle-section]').forEach(initializeBundle);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeBundles(document), { once: true });
    } else {
      initializeBundles(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeBundles(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msc-collection-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('msc-vendor-contact')) {
    customElements.define('msc-vendor-contact', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.status = this.querySelector('[data-status]');
        this.profileRequest = null;
        this.querySelector('details').addEventListener('toggle', () => {
          if (this.querySelector('details').open) this.getVendor().catch(() => {});
        });
        this.form.addEventListener('submit', event => this.send(event));
      }
      async getVendor() {
        if (this.vendorId) return this.vendorId;
        if (!this.profileRequest) {
          this.profileRequest = (async () => {
            const params = new URLSearchParams({shop: this.dataset.shop, vendor: this.dataset.vendor, meta: this.dataset.vendor, collectionId: this.dataset.collection});
            const response = await fetch('https://app.puppetvendors.com/webhooks/vendor/profiles?' + params, {signal: AbortSignal.timeout(15000)});
            if (!response.ok) throw new Error('Vendor unavailable');
            const data = await response.json();
            if (!data._id) throw new Error('Vendor unavailable');
            this.vendorId = data._id;
            this.dataset.connection = 'ready';
            return this.vendorId;
          })().catch(error => {
            this.profileRequest = null;
            this.dataset.connection = 'unavailable';
            throw error;
          });
        }
        return this.profileRequest;
      }
      async send(event) {
        event.preventDefault();
        if (this.sending || !this.form.reportValidity()) return;
        this.sending = true;
        const button = this.form.querySelector('button');
        button.disabled = true;
        this.status.textContent = this.dataset.sending;
        try {
          const vendorId = await this.getVendor();
          const values = new FormData(this.form);
          const content = 'Name: ' + values.get('name') + ', Phone: ' + values.get('phone') + ', Message: ' + values.get('message') + ', Source: ' + location.origin + location.pathname;
          const response = await fetch('https://app.puppetvendors.com/webhooks/customer-message/' + encodeURIComponent(vendorId) + '?source=vendor_message', {
            method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({email: values.get('email'), content})
          });
          if (!response.ok) throw new Error('Message failed');
          this.form.reset();
          this.querySelector('details').open = false;
          this.status.textContent = this.dataset.success;
        } catch (error) {
          this.status.textContent = this.dataset.error;
        } finally {
          this.sending = false;
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msc-state-maker-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('msc-maker-directory')) {
    customElements.define('msc-maker-directory', class extends HTMLElement {
      connectedCallback() {
        this.searchInput = this.querySelector('[data-msc-maker-search]');
        if (!this.searchInput || this.onSearch) return;
        const groups = Array.from(this.querySelectorAll('[data-msc-state-group]'));
        const links = Array.from(this.querySelectorAll('[data-msc-state-link]'));
        const emptyMessage = this.querySelector('[data-msc-maker-empty]');
        this.onSearch = () => {
          const query = this.searchInput.value.trim().toLocaleLowerCase();
          let visibleCount = 0;
          groups.forEach(group => {
            let groupCount = 0;
            group.querySelectorAll('[data-msc-maker-card]').forEach(card => {
              const matches = card.dataset.search.toLocaleLowerCase().includes(query);
              card.hidden = !matches;
              if (matches) groupCount += 1;
            });
            group.hidden = groupCount === 0;
            visibleCount += groupCount;
            const link = links.find(item => item.dataset.mscStateLink === group.dataset.mscStateGroup);
            if (link) link.hidden = groupCount === 0;
          });
          if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
        };
        this.searchInput.addEventListener('input', this.onSearch);
        this.querySelector('[data-msc-maker-search-wrapper]').hidden = false;
        this.onSearch();
      }
      disconnectedCallback() {
        if (this.searchInput && this.onSearch) this.searchInput.removeEventListener('input', this.onSearch);
        this.onSearch = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
